import OrganizationList from './OrganizationList';

export default OrganizationList;
